import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { IconType } from "src/app/tinea-components/icon/enum/icon-type";
import { BaseTableMapper } from "src/app/tinea-components/table/mapper/BaseTableMapper";
import { TableModel } from "src/app/tinea-components/table/models/input/table-model";
import { TableRows } from "src/app/tinea-components/table/models/input/table-rows";
import { TableTd } from "src/app/tinea-components/table/models/input/table-td";
import { TableTh } from "src/app/tinea-components/table/models/input/table-th";
import { ValueCell } from "src/app/tinea-components/table/models/input/value-cell";
import {
  CallNotificationPagedList,
  CallNotificationValidity,
} from "src/swagger-gen/web-secured/models";

@Injectable({
  providedIn: "root",
})
export class TableCallLogListMapper extends BaseTableMapper {
  // -- configuration
  readonly CSS_CLASS_CONFIG = "table-call-log";

  readonly DISPLAY_NO_DATA = "--";

  // -- table
  // dataId

  readonly COLUMN_ID_DATE = "CALL_DATE";
  readonly COLUMN_ID_TYPE = "CALL_TYPE";
  readonly COLUMN_ID_CREATE_TICKET = "CREATE_TICKET";
  readonly COLUMN_ID_INTERVENANT_CODE = "INTERVENANT_CODE";
  readonly COLUMN_ID_DESCRIPTION = "DESCRIPTION";
  readonly COLUMN_ID_CODE = "STATION_CODE";
  readonly COLUMN_ID_STATION = "STATION";
  readonly COLUMN_ID_STATUS = "CALL_STATUS";
  readonly COLUMN_ID_REGROUPEMENT = "REGROUPEMENT";
  readonly COLUMN_ID_PANNE = "PANNE";

  table: TableModel;

  constructor(private translate: TranslateService) {
    super();
    this.table = new TableModel();
  }

  init(callLogs: CallNotificationPagedList): TableModel {
    this.table = new TableModel();
    // configuration
    this.initConfiguration();
    // header
    this.initHeader();
    // data
    this.initDataRow(callLogs);

    return this.table;
  }

  initConfiguration(): void {
    this.table.configuration.cssClass = this.CSS_CLASS_CONFIG;
    this.table.configuration.noDataRowMsg =
      this.translate.instant("error.no_result");
  }

  initHeader(): void {
    // const thSeriousness = new TableTh();
    // thSeriousness.columnId = this.COLUMN_ID_SERIOUSNESS;
    // const thSeriousnessCell = new ValueCell();
    // thSeriousnessCell.displayedValue = this.translate.instant('stations.alarmStation.seriousness');
    // thSeriousness.valueCells.push(thSeriousnessCell);

    const thDate = new TableTh();
    thDate.columnId = this.COLUMN_ID_DATE;
    const thDateCell = new ValueCell();
    thDateCell.displayedValue = this.translate.instant("call-log.table.date");
    thDate.valueCells.push(thDateCell);

    const thType = new TableTh();
    thType.columnId = this.COLUMN_ID_TYPE;
    const thTypeCell = new ValueCell();
    thTypeCell.displayedValue = this.translate.instant("call-log.table.type");
    thType.valueCells.push(thTypeCell);

    const thCode = new TableTh();
    thCode.columnId = this.COLUMN_ID_CODE;
    const thCodeCell = new ValueCell();
    thCodeCell.displayedValue = this.translate.instant("call-log.table.code");
    thCode.valueCells.push(thCodeCell);

    const thStation = new TableTh();
    thStation.columnId = this.COLUMN_ID_STATION;
    const thStationCell = new ValueCell();
    thStationCell.displayedValue = this.translate.instant(
      "call-log.table.station"
    );
    thStation.valueCells.push(thStationCell);

    const thIntervenantCode = new TableTh();
    thIntervenantCode.columnId = this.COLUMN_ID_INTERVENANT_CODE;
    const thIntervenantCodeCell = new ValueCell();
    thIntervenantCodeCell.displayedValue = this.translate.instant(
      "call-log.table.intervenantCode"
    );
    thIntervenantCode.valueCells.push(thIntervenantCodeCell);

    const thPanne = new TableTh();
    thPanne.columnId = this.COLUMN_ID_PANNE;
    const thPanneCell = new ValueCell();
    thPanneCell.displayedValue = this.translate.instant("call-log.table.panne");
    thPanne.valueCells.push(thPanneCell);

    const thdescription = new TableTh();
    thdescription.columnId = this.COLUMN_ID_DESCRIPTION;
    const thDescriptionCell = new ValueCell();
    thDescriptionCell.displayedValue = this.translate.instant(
      "call-log.table.description"
    );
    thdescription.valueCells.push(thDescriptionCell);

    const thCreateTiclet = new TableTh();
    thCreateTiclet.columnId = this.COLUMN_ID_CREATE_TICKET;
    const thCreateTicletCell = new ValueCell();
    thCreateTicletCell.displayedValue = this.translate.instant(
      "call-log.table.createTicket"
    );
    thCreateTiclet.valueCells.push(thCreateTicletCell);

    const thstatus = new TableTh();
    thstatus.columnId = this.COLUMN_ID_STATUS;
    const thstatusCell = new ValueCell();
    thstatusCell.displayedValue = this.translate.instant(
      "call-log.table.status"
    );
    thstatus.valueCells.push(thstatusCell);

    const thList = [
      thDate,
      thCode,
      thStation,
      thType,
      thIntervenantCode,
      thdescription,
      thPanne,
      thCreateTiclet,
      thstatus,
    ];

    this.setHeaderCells(thList);
  }

  initDataRow(callLogs: CallNotificationPagedList): void {
    callLogs.list.forEach((log) => {
      // const cssClassSeriousness = this.getcssClassSeriousness(alarm.seriousness);
      const tableRows = new TableRows(log);
      // tableRows.row.cssClass = (tableRows.row.obj.state ===  AlarmState.RAISED) ? this.CSS_CLASS_SERIOUSNESS_ACQUIT : null;
      // td - seriousness
      // const seriousness = new TableTd();
      // const seriousnessCell = new ValueCell();
      // seriousnessCell.displayedValue = '';
      // seriousnessCell.iconList.iconAfter = [];
      // --icon
      // const seriousnessIcon =  new UiIcon();
      // seriousnessIcon.type = IconType.ICOMOON;
      // seriousnessIcon.value = 'icon-bell1';
      // seriousnessIcon.cssClass = cssClassSeriousness;
      // seriousnessCell.iconList.iconAfter.push(seriousnessIcon);
      // seriousness.valueCells.push(seriousnessCell);

      // td - date
      const date = new TableTd();
      const dateCell = new ValueCell();
      dateCell.displayedValue = log.callDate;
      dateCell.dataType = "DATE";
      date.valueCells.push(dateCell);

      // td - type
      const type = new TableTd();
      const typeCell = new ValueCell();
      typeCell.displayedValue = log.callType
        ? this.translate.instant("call-log.type." + log.callType)
        : this.DISPLAY_NO_DATA;
      if (log.callType) {
        typeCell.addCss(log.callType.toLowerCase());
      }

      type.valueCells.push(typeCell);

      // td - station
      const code = new TableTd();
      const codeCell = new ValueCell();
      codeCell.displayedValue = log.station
        ? log.station.code
        : this.DISPLAY_NO_DATA;
      code.valueCells.push(codeCell);

      // td - station
      const station = new TableTd();
      const stationCell = new ValueCell();
      stationCell.displayedValue = log.station
        ? log.station.name
        : this.DISPLAY_NO_DATA;
      station.valueCells.push(stationCell);

      // td - intervenant Code
      const intervenantCode = new TableTd();
      const intervenantCodeCell = new ValueCell();
      intervenantCodeCell.displayedValue = log.intervenantCode
        ? log.intervenantCode
        : this.DISPLAY_NO_DATA;
      intervenantCode.valueCells.push(intervenantCodeCell);

      // td - Panne
      const panne = new TableTd();
      const panneCell = new ValueCell();
      panneCell.displayedValue = log.panne ? log.panne : this.DISPLAY_NO_DATA;
      panne.valueCells.push(panneCell);

      // td - DESCRIPTION
      const description = new TableTd();
      const descriptionCell = new ValueCell();
      descriptionCell.displayedValue = log.description
        ? log.description
        : this.DISPLAY_NO_DATA;
      description.valueCells.push(descriptionCell);

      // td - CREATE TICKET & CALL EXPIRED
      const createTicket = new TableTd();
      const createTicketCell = new ValueCell();
      createTicketCell.displayedValue =
        log.createTicket != undefined && log.createTicket
          ? this.translate.instant("dashboardGNL.table.yes")
          : this.translate.instant("dashboardGNL.table.no");

      if (log.validity === CallNotificationValidity.CALL_DATE_TOO_OLD) {
        createTicketCell.addIcon('AFTER',
          IconType.FONTAWESOME,
          'fa-regular fa-clock',
          'call-expired');
        createTicketCell.tooltip = this.translate.instant('call-log.expired');
        createTicketCell.tooltipPosition = 'above';
      }

      createTicket.valueCells.push(createTicketCell);

      // td - Status
      const status = new TableTd();
      const statuseCell = new ValueCell();
      statuseCell.displayedValue = log.callStatus
        ? this.translate.instant("call-log.status." + log.callStatus)
        : this.DISPLAY_NO_DATA;
      if (log.callStatus) {
        statuseCell.addCss(log.callStatus);
      }

      status.valueCells.push(statuseCell);

      // add cells
      // ================>
      tableRows.cells = [
        date,
        code,
        station,
        type,
        intervenantCode,
        description,
        panne,
        createTicket,
        status,
      ];

      // push row
      // ================>
      this.table.dataRow.push(tableRows);
    });
  }

  setHeaderCells(thList: TableTh[]): void {
    this.table.header.cells = thList;
  }
}
